import { InAppState } from "../base/InAppState";
import template from "./SpaTemplate.html";

import { _lcs } from "../../i18n";

/**
 * SpaState — "Spa & Wellness" sub-page (`/spa`): opening hours, guest access
 * and the treatment menu with a booking CTA. Reached from the home quick
 * action and the menu drawer.
 */
export class SpaState extends InAppState
{
    static ROUTE = "/spa";
    static ID = "spa";

    showsBottomNav() { return false; }

    async enter()
    {
        this.renderScreen( template, {
            house: this._houseName(),
            treatments: [
                { title: _lcs( "Aufguss-Zeremonie" ),       dur: _lcs( "25 Min" ), price: _lcs( "inkl." ), icon: "flame" },
                { title: _lcs( "Klassische Rückenmassage" ), dur: _lcs( "50 Min" ), price: "65 €",             icon: "hand" },
                { title: _lcs( "Kräuterstempel-Massage" ),   dur: _lcs( "80 Min" ), price: "98 €",             icon: "leaf" },
                { title: _lcs( "Gesichtsbehandlung Natur" ), dur: _lcs( "60 Min" ), price: "79 €",             icon: "sparkles" }
            ]
        } );

        const root = this.app.view.pageContent;
        this.addEventListener( root.querySelector( '[data-id="back"]' ), "click", () => this.app.router.redirect( "/" ) );
        this.addEventListener( root.querySelector( '[data-id="book"]' ), "click", () => this.app.view.toast( _lcs( "Wir melden uns mit einem Terminvorschlag." ), "success" ) );
    }

    _houseName()
    {
        const slug = this.app.theme.getTenantSlug();
        if ( !slug )
        {
            return "Gästehaus Felsenblick";
        }
        return slug
            .split( "-" )
            .map( ( w ) => w.charAt( 0 ).toUpperCase() + w.slice( 1 ) )
            .join( " " );
    }
}
